export const ComponentsAdd = ({
  size = 36,
  weight = 'normal',
  color = undefined,
}: {
  size?: number;
  weight?: 'fill' | 'normal';
  color?: string;
}) => {
  const tcolor = color || 'currentColor';
  const bcolor = weight === 'fill' ? tcolor : undefined;

  return (
    <svg width={size} height={size} viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M104 48H56C51.5817 48 48 51.5817 48 56V104C48 108.418 51.5817 112 56 112H104C108.418 112 112 108.418 112 104V56C112 51.5817 108.418 48 104 48Z"
        stroke={tcolor}
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={bcolor}
      />
      <path
        d="M200 48H152C147.582 48 144 51.5817 144 56V104C144 108.418 147.582 112 152 112H200C204.418 112 208 108.418 208 104V56C208 51.5817 204.418 48 200 48Z"
        stroke={tcolor}
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={bcolor}
      />
      <path
        d="M104 144H56C51.5817 144 48 147.582 48 152V200C48 204.418 51.5817 208 56 208H104C108.418 208 112 204.418 112 200V152C112 147.582 108.418 144 104 144Z"
        stroke={tcolor}
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={bcolor}
      />
      <path d="M176 144V208" stroke={tcolor} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M208 176H144" stroke={tcolor} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
